module.exports = __webpack_public_path__ + "johanniter-logo.svg?8cd033423d2d863f041839e714ff4049";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/johanniter-logo.svg
// module id = 68
// module chunks = 0